import { CRMAPIBase } from '@api/crmApiBase';
import { BrigadeListResp } from '@api/responseModels/brigades/brigadeListResponse';
import { BrigadeResp } from '@api/responseModels/brigades/brigadeResponse';
import { RequestResult } from '@api/responseModels/requestResult';

class BrigadesGroup extends CRMAPIBase {
    async getBrigadeList({
        crm_id,
        page,
        per_page,
        parent_brigade_id,
    }): Promise<RequestResult<BrigadeListResp>> {
        const result = await this.get<BrigadeListResp>(`/brigades`, {
            crm_id,
            page,
            per_page,
            parent_brigade_id,
        });
        return result;
    }

    async getBrigade(id: number, crmId: number): Promise<RequestResult<BrigadeResp>> {
        const result = await this.get<BrigadeResp>(`/brigades/${id}`, {
            crm_id: crmId,
            parent_brigade_id: null,
        });
        return result;
    }

    async createBrigade(params: {
        crm_id: number;
        name: string;
        workerPositions: Array<{ id: number; role: 'brigadier' | 'worker' }>;
        parent_brigade_id: number | null;
        brigadier_participates: boolean;
    }): Promise<RequestResult<BrigadeResp>> {
        const result = await this.post<BrigadeResp>('/brigades', params);
        return result;
    }

    async updateBrigade(
        id: number,
        params: {
            crm_id: number;
            name: string;
            workerPositions: Array<{ id: number; role: 'brigadier' | 'worker' }>;
            parent_brigade_id: number | null;
            brigadier_participates: boolean;
        }
    ): Promise<RequestResult<BrigadeResp>> {
        const result = await this.put<BrigadeResp>(`/brigades/${id}`, params);
        return result;
    }

    async deleteBrigade(id: number, crmId: number): Promise<RequestResult<BrigadeResp>> {
        const result = await this.delete<BrigadeResp>(`/brigades/${id}`, { crm_id: crmId });
        return result;
    }
}

export { BrigadesGroup };
